<template>
  <b-form>
    <b-row>
      <b-col cols="12" md="6" lg="4">
        <h3 class="mr-2">Dépenses Administratives :</h3>
        <span>{{
            (bidData.inventory && bidData.inventory.total_admin_expenses) ? amountToCurrency(bidData.inventory.total_admin_expenses) : '0'
        }}</span>
      </b-col>
      <b-col cols="12" md="6" lg="4">
        <h3 class="mr-2">Devis HT :</h3>
        <span>{{ (bidData.inventory && bidData.inventory.total_pretax) ? amountToCurrency(bidData.inventory.total_pretax) : '0' }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-4">
        <b-button
          v-if="!isLost && !isWon && !isClosed"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="warning"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="toggleAsLost"
        >
          <span
            ><feather-icon class="mr-1" size="16" icon="Trash2Icon" />Définir
            Comme Perdue</span
          >
        </b-button>
        <b-button
          v-if="isWon && !isClosed"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="mr-2"
          variant="danger"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="closeProject"
        >
          <span
            ><feather-icon class="mr-1" size="16" icon="SlashIcon" />Fermer l'offre</span
          >
        </b-button>

        <b-button
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            variant="outline-secondary"
            @click="() => $router.go(-1)"
        >
          Retour
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { BRow, BCol, BForm, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { amountToCurrency } from "@/utils/formatAmount";
import { toRefs } from "@vue/composition-api";
import useBidDetails from "@/views/apps/bid/bids-view/useBidDetails";
import router from "@/router";

export default {
  name: "BidEditTabState",
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: ["bidData"],
  setup(props, { emit }) {
    const {
      toggleAsLost,
      closeProject,
      isLost,
      isWon,
      isClosed,
    } = useBidDetails(toRefs(props), emit)
    return {
      toggleAsLost,
      closeProject,
      amountToCurrency,
      isLost,
      isWon,
      isClosed
    };
  },
};
</script>

<style></style>
